"use client";

import { c as _c } from "react/compiler-runtime";
import { BodyLong, Tag } from "@navikt/ds-react";
import { ComponentHeader } from "@/components/header/ComponentHeader";
import { MottattVurderingDetaljer } from "@/components/view/mottattVurdering/MottattVurderingDetaljer";
import type { AktivitetskravVurdering } from "@/schema/aktivitetskravVurderingSchema";
import { getShortDateFormat } from "@/utils/dateUtils";
interface Props {
  vurdering: AktivitetskravVurdering;
}
export const MottattVurderingComponent = t0 => {
  const $ = _c(17);
  const {
    vurdering
  } = t0;
  let t1;
  if ($[0] !== vurdering.sistVurdert) {
    t1 = <ComponentHeader headerText="NAV har vurdert aktivitetsplikten din" utsendtDato={vurdering.sistVurdert} alertStyle="success" />;
    $[0] = vurdering.sistVurdert;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <BodyLong>Hei!</BodyLong>;
    t3 = <BodyLong>Alle sykmeldte skal i utgangspunktet jobbe litt hvis de kan, også hvis de er 100 % sykmeldt. Dette kalles aktivitetsplikten.</BodyLong>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== vurdering) {
    t4 = <MottattVurderingDetaljer vurdering={vurdering} />;
    $[4] = vurdering;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <BodyLong>Aktivitetsplikten gjelder gjennom hele sykefraværet og det kan være at NAV vurderer aktivitetsplikten din igjen på et senere tidspunkt.</BodyLong>;
    t6 = <BodyLong>Selv om du har fått unntak fra aktivitetsplikten nå, skal du fremdeles samarbeide med arbeidsgiver og/eller Nav for å komme tilbake i jobb. Dette kalles medvirkningsplikten.</BodyLong>;
    t7 = <BodyLong>Denne vurderingen er tilgjengelig for deg på Min side i 30 dager fra vurderingen til NAV ble gjort.</BodyLong>;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
  }
  let t8;
  if ($[9] !== vurdering.sistVurdert) {
    t8 = vurdering.sistVurdert && <Tag variant="success-moderate" className="w-fit mt-4">Dato for vurdering: {getShortDateFormat(vurdering.sistVurdert)}</Tag>;
    $[9] = vurdering.sistVurdert;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t4 || $[12] !== t8) {
    t9 = <div className="flex flex-col gap-4">{t2}{t3}{t4}{t5}{t6}{t7}{t8}</div>;
    $[11] = t4;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t1 || $[15] !== t9) {
    t10 = <>{t1}{t9}</>;
    $[14] = t1;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
};